import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faChevronsLeft } from "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import { faChevronsRight } from "@fortawesome/pro-solid-svg-icons/faChevronsRight";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./Paginator.module.scss";

export interface PaginatorProps {
    // defaultPageIndex = 0,
    className?: string;
    index: number;
    count: number;
    total: number;
    onPageSelect: (index: number) => void;
}

export const Paginator: React.FC<PaginatorProps> = ({ count, total, index, className, onPageSelect }) => {
    if (count <= 1) return null;

    return (
        total > 0 && (
            <div className={`${styles["paginator"]} ${className ?? ""}`}>
                <div className={`${styles["summary"]}`}>{total} results</div>
                {count > 1 && (
                    <div className={`${styles["nav"]}`}>
                        {count > 2 && (
                            <button
                                className={`${index === 0 ? styles["disabled"] : ""}`}
                                onClick={() => {
                                    onPageSelect(0);
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronsLeft} />
                            </button>
                        )}
                        {
                            <button
                                className={`${index === 0 ? styles["disabled"] : ""}`}
                                onClick={() => {
                                    onPageSelect(index - 1);
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                        }
                        <span>
                            Page {index + 1} of {count}
                        </span>
                        {
                            <button
                                className={`${index === count - 1 ? styles["disabled"] : ""}`}
                                onClick={() => {
                                    onPageSelect(index + 1);
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        }
                        {count > 2 && (
                            <button
                                className={`${index === count - 1 ? styles["disabled"] : ""}`}
                                onClick={() => {
                                    onPageSelect(count - 1);
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronsRight} />
                            </button>
                        )}
                    </div>
                )}
            </div>
        )
    );
};
